import React, { useState, useEffect } from 'react';
import FileForDownloadService from '../Services/FileForDownloadService';
import ErrorMessage from './ErrorMessage';

// Nav indicator only (dot / number). The new-download popup lives in
// NotificationTriggers.tsx (CD-5276); no longer uses props.message / SetIcon.
export default function NumberOfUndownloadedFiles({ showNumber = false, notificationsWithoutNumberDropDown = false }) {
  const [numberOfFiles, setNumberOfFiles] = useState(0);

  useEffect(() => {
    let timer = null;
    let cancelled = false;
    const poll = () => {
      FileForDownloadService.GetNumberOfUndownloadedFiles()
        .then((result) => {
          if (cancelled) return;
          // Preserve legacy quirk: a falsy response stops the poll loop (no reschedule).
          if (!result) return;
          setNumberOfFiles(result.numberOfFiles);
          if (ErrorMessage.NotDev()) timer = window.setTimeout(poll, 60000);
        })
        .catch(() => { if (!cancelled) timer = window.setTimeout(poll, 600000); });
    };
    poll();
    return () => { cancelled = true; if (timer) window.clearTimeout(timer); };
  }, []);

  if (numberOfFiles === 0) return null;
  if (showNumber === true) return <span className='badge'>{numberOfFiles}</span>;
  if (notificationsWithoutNumberDropDown === true) return <span className='notificationsWithoutNumberDropDown' />;
  return <span className='notificationsWithoutNumber' />;
}
